:host {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    label {
        color: var(--solid-ui-color-gray-600);
        font-size: var(--solid-ui-font-size-sm);
        font-weight: 400;
    }

    wa-popup {
        display: block;
        width: 100%;
    }

    wa-popup::part(popup) {
        background: white;
        border: 1px solid var(--solid-ui-color-gray-100);
        border-radius: 5px;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.35);
        overflow: hidden;
        padding: 4px;
    }

    .input-wrapper {
        position: relative;
        width: 100%;

        input {
            border: 1px solid var(--solid-ui-color-gray-400);
            border-radius: 5px;
            padding: 10px;
            padding-right: 40px;
            width: 100%;
        }

        icon-lucide-chevron-down {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--solid-ui-color-gray-500);
            width: var(--solid-ui-font-size-lg);
            height: var(--solid-ui-font-size-lg);
            pointer-events: none;
        }
    }

    .listbox {
        display: flex;
        flex-direction: column;
        gap: 2px;
        max-height: min(28rem, calc(100dvh - 6rem), var(--auto-size-available-height, 28rem));
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 4px;
        }

        [role="option"], .non-selectable-option {
            color: var(--solid-ui-color-gray-700);
            padding: 12px 8px;
            border-radius: 5px;
        }

        [role="option"] {
            cursor: pointer;

            &:hover,
            &[data-active] {
                background: var(--solid-ui-color-primary-hover);
            }

            &[aria-selected="true"] {
                background: var(--solid-ui-color-primary-selected);
            }
        }

        .non-selectable-option {
            display: flex;
            justify-content: center;
            align-items: center;

            icon-svg-spinners-3-dots-fade {
                width: 2rem;
            }

            .message--error {
                color: var(--solid-ui-color-error);
            }
        }
    }
}
